import { Typography } from '@recruit-robin/robin-theme/web-components';
import { RobinLogo } from '@recruit-robin/robin-theme/web-icons';

import { useDictionary } from '@/shared/lib/i18n';

import { useStyles } from './PoweredByRobin.styles';

export type PoweredByRobinProps = {
  onUnsubscribe?: () => void;
  isPoweredByOnly?: boolean;
  isEmail?: boolean;
  showDivider?: boolean;
};

const unsubscribeLinkStyle = { textDecoration: 'underline', color: 'inherit' } as const;

const privacyPolicyUrl = 'https://www.recruitrobin.com/legal/privacyverklaring';

export const PoweredByRobin = ({
  onUnsubscribe,
  isPoweredByOnly = false,
  isEmail = true,
  showDivider = true,
}: PoweredByRobinProps) => {
  const classes = useStyles({ showDivider });
  const dictionary = useDictionary();

  return (
    <div css={[classes.root, isPoweredByOnly && classes.rootPoweredByOnly]}>
      {!isPoweredByOnly && (
        <div css={classes.footerMessage}>
          {isEmail && (
            <Typography variant={(v) => v.supporting.helper} color={(c) => c.neutral.variant[50]}>
              {dictionary.emailFooterDoNotReply}
            </Typography>
          )}
          <Typography variant={(v) => v.supporting.helper} color={(c) => c.neutral.variant[50]}>
            {isEmail
              ? dictionary.emailFooterRobinProcesses
              : dictionary.robinUsesYourActivityOnThisPageForBetterMatches}
          </Typography>
          <div css={classes.links}>
            <Typography variant={(v) => v.supporting.helper} color={(c) => c.secondary.sky[50]}>
              {onUnsubscribe ? (
                <a
                  href="#unsubscribe"
                  style={unsubscribeLinkStyle}
                  onClick={(event) => {
                    event.preventDefault();
                    onUnsubscribe();
                  }}>
                  {dictionary.emailFooterUnsubscribe}
                </a>
              ) : (
                <a href="#" style={unsubscribeLinkStyle}>
                  {dictionary.emailFooterUnsubscribe}
                </a>
              )}
            </Typography>
            <Typography variant={(v) => v.supporting.helper} color={(c) => c.neutral.variant[50]}>
              |
            </Typography>
            <Typography variant={(v) => v.supporting.helper} color={(c) => c.secondary.sky[50]}>
              <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer" style={unsubscribeLinkStyle}>
                {dictionary.emailFooterPrivacyPolicy}
              </a>
            </Typography>
          </div>
        </div>
      )}
      <div css={classes.poweredBy}>
        <Typography variant={(v) => v.supporting.helper} color={(c) => c.neutral.variant[80]}>
          {dictionary.poweredBy}
        </Typography>
        <RobinLogo height={16} />
      </div>
    </div>
  );
};
